"use client";
import { SlOptions } from "react-icons/sl";
import classes from "./PopperComponent.module.css";
import * as Popover from "@radix-ui/react-popover";
import { cn } from "@/utils";
import { useMediaQuery } from "@/customHooks/useMediaQuery";
import { cloneElement, useState } from "react";
import { IoClose } from "react-icons/io5";

const PopperComponent = ({
  anchorRef,
  data,
  popperInsideElement,
  handleClick,
  isCloseOnClick = true,
  side,
  spaceBetweenTrigger,
  align = "center",
  children = <SlOptions />,
  arrow,
  boundary,
  showCloseButton = false,
  className,
  // Optional small heading above the list, e.g. "Select venue".
  title,
}) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [open, setOpen] = useState(false);
  return (
    <>
      <Popover.Root modal={false} open={open} onOpenChange={setOpen}>
        <Popover.Trigger className={classes.popperTrigger} ons>
          {children}
        </Popover.Trigger>
        <Popover.Portal
          className={classes.popperPortal}
          container={anchorRef && anchorRef.current ? anchorRef.current : null}
        >
          <Popover.Content
            className={cn(
              classes.popperContent,
              popperInsideElement && classes.popperInsideElement,
              showCloseButton && classes.closeButtonParent,
            )}
            side={isMobile ? "bottom" : side}
            sideOffset={spaceBetweenTrigger}
            align={align}
            sticky="partial"
            collisionBoundary={boundary ? boundary.current : []}
            hideWhenDetached
          >
            {title && <p className={classes.popperTitle}>{title}</p>}
            {data?.length > 0 && (
              <div className={cn(classes.list, className)}>
                {data?.map((item, i) => {
                  return (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick(item);
                        isCloseOnClick && setOpen(false);
                      }}
                      className={classes.menuItem}
                      key={i}
                      style={{ color: item?.color }}
                    >
                      {item?.icon} {item?.value}
                    </span>
                  );
                })}
              </div>
            )}
            {popperInsideElement &&
              cloneElement(
                popperInsideElement,
                {
                  className: cn(
                    classes.insideElement,
                    popperInsideElement.props.className,
                  ),
                },
                [
                  showCloseButton && (
                    <Popover.Close className={classes.closeButton}>
                      <IoClose />
                    </Popover.Close>
                  ),
                  popperInsideElement.props.children,
                ],
              )}
            {arrow && <Popover.Arrow className={classes.popperArrow} />}
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </>
  );
};

export default PopperComponent;
